import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import ReportList from '../components/Reports/ReportList';
import GenerateReport from '../components/Reports/GenerateReport';
import LoadingSpinner from '../components/UI/LoadingSpinner';

const Reports: React.FC = () => {
  const [selectedType] = useState<string>('all');
  // const queryClient = useQueryClient();
  const [isGenerating, setIsGenerating] = useState(false);
  const [filters, setFilters] = useState({ type: '' });

  const { data: reports, isLoading, error, refetch } = useQuery({
    queryKey: ['reports', selectedType],
    queryFn: () => apiClient.getReports(selectedType === 'all' ? undefined : selectedType),
    refetchInterval: 60000, // Refresh every minute
  });

  // const generateReportMutation = useMutation({
  //   mutationFn: (type: 'hourly' | 'daily' | 'weekly' | 'monthly') => 
  //     apiClient.generateReport(type),
  //   onSuccess: () => {
  //     queryClient.invalidateQueries({ queryKey: ['reports'] });
  //   },
  // });

  const handleGenerateReport = (type: 'hourly' | 'daily' | 'weekly' | 'monthly') => {
    setIsGenerating(true);
    // In real implementation, this would call the API
    console.log(`Generating ${type} report...`);
    
    // Simulate API call
    setTimeout(() => {
      setIsGenerating(false);
      // Refetch reports
      refetch();
    }, 3000);
  };

  // const reportTypes = [
  //   { value: 'all', label: 'All Reports' },
  //   { value: 'hourly', label: 'Hourly' },
  //   { value: 'daily', label: 'Daily' },
  //   { value: 'weekly', label: 'Weekly' },
  //   { value: 'monthly', label: 'Monthly' },
  // ];

  const filteredReports = reports || [];

  return (
    <div className="space-y-8">
      {/* Page Header */}
      <div className="border-b border-gray-200 pb-4">
        <h1 className="text-2xl font-bold text-gray-900">Audit Reports</h1>
        <p className="text-gray-600 mt-1">Generate and review audit reports</p>
      </div>

      {/* Generate Report Section */}
      <GenerateReport 
        onGenerate={handleGenerateReport}
        isGenerating={isGenerating}
      />

      {/* Reports List */}
      <div className="bg-white rounded-lg shadow">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-medium text-gray-900">Audit Reports</h2>
              <p className="text-sm text-gray-500 mt-1">
                Generated audit reports and compliance documentation
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <select 
                value={filters.type}
                onChange={(e) => setFilters(prev => ({ ...prev, type: e.target.value }))}
                className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
              >
                <option value="">All Types</option>
                <option value="hourly">Hourly</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
          </div>
        </div>

        {isLoading ? (
          <div className="px-6 py-12 text-center">
            <LoadingSpinner />
          </div>
        ) : error ? (
          <div className="px-6 py-12 text-center">
            <div className="text-red-400 mb-4">
              <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.314 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Error loading reports</h3>
            <p className="text-gray-500">Unable to load audit reports. Please try again.</p>
          </div>
        ) : (
          <ReportList reports={filteredReports} />
        )}
      </div>
    </div>
  );
};

export default Reports; 